import * as Yup from 'yup';

import { PaymentMethodType } from 'types';
import { Chargeback } from 'store/api/accounting';
import { formatPrice, joinStrings } from 'utils/helpers';
import { formatDate, formatTimezoneSpecific } from 'utils/date';

import { FormValues } from './types';

export const getInfoItems = (data?: Chargeback) => {
  const creditPayment = data?.checkout?.paymentMethods?.find(
    (item) => item.type === PaymentMethodType.Credit
  );

  return [
    {
      value: data?.id,
      title: 'Case Number',
    },
    {
      title: 'Transaction Date',
      value: formatTimezoneSpecific(
        data?.checkout?.createdAt,
        data?.checkout?.event?.timezone?.code,
        'L LT'
      ),
    },
    {
      title: 'Sales Rep',
      value: joinStrings(
        (data?.checkout?.commissions?.length
          ? data?.checkout?.commissions
          : data?.checkout?.lostCommissions
        )?.map((commission) => commission?.user?.name) || [],
        ', '
      ),
    },
    {
      title: 'Location',
      value: data?.checkout?.event?.name,
    },
    {
      title: 'Dispute Amount',
      value: formatPrice(data?.checkout?.saleTotal),
    },
    {
      title: 'Card',
      value: creditPayment?.last4CC,
    },
    {
      title: 'Case Numbers',
      value: joinStrings(data?.fiservChargeback?.caseNumbers || [], ', '),
    },
    {
      title: 'Due Date',
      value: data?.dueDate && formatDate(data?.dueDate, 'L LT'),
    },
    {
      title: 'Date of Report',
      value: data?.responseDate && formatDate(data?.responseDate, 'L LT'),
    },
    {
      title: 'Customer',
      value: data?.checkout?.customer?.person?.name,
    },
    {
      title: 'Reason',
      value: data?.reason,
    },
  ];
};

export const getInitialValues = (data?: Chargeback): FormValues => ({
  responseDate: data?.responseDate ? formatDate(data?.responseDate) : '',
});

export const validationSchema = Yup.object().shape({
  responseDate: Yup.string().required(),
});
